import { render, staticRenderFns } from "./FormForgot.vue?vue&type=template&id=7c83fc25&scoped=true&"
import script from "./FormForgot.vue?vue&type=script&lang=js&"
export * from "./FormForgot.vue?vue&type=script&lang=js&"
import style0 from "./FormForgot.vue?vue&type=style&index=0&id=7c83fc25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c83fc25",
  null
  
)

export default component.exports